import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-insights",
  "use": "icon-insights-usage",
  "viewBox": "0 0 25 24",
  "content": "<symbol viewBox=\"0 0 25 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-insights\">\n<g id=\"icon-insights_Frame 1171277281\">\n<path id=\"icon-insights_Vector 496\" d=\"M3.33325 19H21.3333\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path id=\"icon-insights_Vector 497\" d=\"M3.33325 15L9.83325 9.02778L14.036 12.8125L21.3333 5M21.3333 5H16.3333M21.3333 5V9.6875\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol